import { SpinResponse } from '@cgs/data-access';
import { EndCollapseToBeginCollapse } from '../free_fall_reels_engine/rules/end_collapse_to_begin_collapse';
import { StopToBeginCollapseState } from '../free_fall_reels_engine/rules/stop_to_begin_collapse';
import { StopToShiftingCollapse } from '../free_fall_reels_engine/rules/stop_to_shifting_collapse';
import { BaseGameRule } from '../state_machine/rules/infra/base_game_rule';
import { StopToBeginFreeSpins } from '../state_machine/rules/stop_to_begin_free_spins';
import { StopToBeginScatter } from '../state_machine/rules/stop_to_begin_scatter';
import { StopToBonus } from '../state_machine/rules/stop_to_bonus';
import { StopToEndFreeSpins } from '../state_machine/rules/stop_to_end_free_spins';
import { StopToFreeSpins } from '../state_machine/rules/stop_to_free_spins';
import { StopToRegularSpin } from '../state_machine/rules/stop_to_regular_spin';
import { BaseGameState } from '../state_machine/states/base_game_state';
import { GameStateMachineStates } from '../state_machine/game-state-machine-states';
import { ExtendedGameStateMachine } from '../state_machine/extended_game_state_machine';

export class CollapseGameStateMachine<
  TResponse extends SpinResponse,
> extends ExtendedGameStateMachine<TResponse> {
  public collapseState: BaseGameState<TResponse>;
  public beginCollapseState: BaseGameState<TResponse>;
  public endCollapseState: BaseGameState<TResponse>;

  protected createStates(): void {
    this.beginCollapseState = this.createBaseState(GameStateMachineStates.BeginCollapse);
    this.collapseState = this.createBaseState(GameStateMachineStates.Collapse);
    this.endCollapseState = this.createBaseState(GameStateMachineStates.EndCollapse);

    super.createStates();
  }

  protected createRules(): void {
    this.appendRule(
      this.stop,
      this.beginCollapseState,
      (s, r) => new StopToBeginCollapseState<TResponse>(s, r)
    );

    this.appendRule(
      this.stop,
      this.shortWinLines,
      (s, r) => new StopToShiftingCollapse<TResponse>(s, r)
    );

    this.appendRule(
      this.shortWinLines,
      this.beginCollapseState,
      (s, r) => new StopToShiftingCollapse<TResponse>(s, r)
    );

    this.appendRule(
      this.beginCollapseState,
      this.collapseState,
      (s, r) => new BaseGameRule<TResponse>(s, r)
    );

    this.appendRule(
      this.collapseState,
      this.endCollapseState,
      (s, r) => new BaseGameRule<TResponse>(s, r)
    );

    this.appendRule(
      this.endCollapseState,
      this.shortWinLines,
      (t, r) => new StopToShiftingCollapse<TResponse>(t, r)
    );

    this.appendRule(
      this.endCollapseState,
      this.animation,
      (s, r) => new StopToBonus<TResponse>(s, r)
    );

    this.appendRule(
      this.endCollapseState,
      this.animation,
      (s, r) => new StopToBeginScatter<TResponse>(s, r)
    );

    this.appendRule(
      this.endCollapseState,
      this.animation,
      (s, r) => new StopToBeginFreeSpins<TResponse>(s, r)
    );

    this.appendRule(
      this.endCollapseState,
      this.animation,
      (s, r) => new StopToFreeSpins<TResponse>(s, r)
    );

    this.appendRule(
      this.endCollapseState,
      this.animation,
      (s, r) => new StopToEndFreeSpins<TResponse>(s, r)
    );

    this.appendRule(
      this.endCollapseState,
      this.animation,
      (s, r) => new StopToRegularSpin<TResponse>(s, r)
    );

    this.appendRule(
      this.endCollapseState,
      this.beginCollapseState,
      (t, r) => new EndCollapseToBeginCollapse<TResponse>(t, r)
    );

    super.createRules();
  }
}
